export default __webpack_public_path__ + "static/media/logo.46bd8333.png";